import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../../icon/';
import Dismiss from '../../__partials/dismiss';
import idGenerator from '../../__utils/idGenerator';
import './style.scss';

const SearchInput = ({
  size,
  name,
  disabled,
  hasError,
  className,
  qaId,
  inputRef,
  onDismissClick,
  ...props
}) => {
  // We need to ensure that if a name is not included, we autogenerate
  // one so that the label and input are connected.
  let newName = name;

  if (!newName) {
    newName = idGenerator();
  }

  const formItemClasses = classNames('uni-form__item', 'l-grid__item', {
    [`uni-form--${size}`]: size,
    'uni-form__item--is-error': hasError,
    'uni-form__item--is-disabled': disabled,
    [className]: className,
  });

  const searchInputClasses = classNames('uni-form__control', 'l-form__control', 'uni-search-input', {
    [`uni-search-input--${size}`]: size,
  });

  return (
    <div className={formItemClasses}>
      <div className={searchInputClasses}>
        <div className="uni-search-input__icon">
          <Icon type="search" color="nonessential" size={size === 'xsmall' ? 'small' : size} />
        </div>
        <input
          type="search"
          className="uni-form__input"
          id={newName}
          disabled={disabled}
          data-qa-id={qaId}
          ref={inputRef}
          {...props}
        />
        <div className="uni-search-input__dismiss">
          <Dismiss size="small" onClick={onDismissClick} />
        </div>
      </div>
    </div>
  );
};

SearchInput.propTypes = {
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  className: PropTypes.string,
  qaId: PropTypes.string,
  inputRef: PropTypes.func,
  onDismissClick: PropTypes.func,
};

SearchInput.defaultProps = {
  size: 'medium',
  disabled: false,
  hasError: false,
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/forms/search-input/index.jsx